import { Skeleton } from '@aimsos/ui';

import { GROUPS_GRID_CLASS } from '../../constants/groups';

const PLACEHOLDER_CARDS = Array.from({ length: 6 }, (_, index) => index);

/** Same grid wrapper as the loaded cards, with placeholder blocks while the groups load. */
function GroupsGridSkeleton() {
  return (
    <div
      data-testid="groups-loading"
      aria-busy="true"
      className={GROUPS_GRID_CLASS}
    >
      {PLACEHOLDER_CARDS.map((index) => (
        <Skeleton key={index} height="112px" borderRadius="8px" />
      ))}
    </div>
  );
}

export default GroupsGridSkeleton;
